import { changeHotel, getMainPageMeta } from 'actions/hotel';
import { getHomeNewsList } from 'actions/news';
import { getPopupIndex } from 'actions/popup';
import { getEachHotelAttractions } from 'actions/attraction';

import { lanMapRoute, changeLng } from 'util/i18n';

export default store => ({
	path: 'main',
	onEnter: () => {
		const {
			hotel: { hotel },
		} = store.getState();

		if (hotel !== 'main') {
			store.dispatch(changeHotel('main'));
		}
	},
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('../Home').default;
					cb(null, component);
				},
				'Main',
			),
		onEnter: () => {
			const {
				global: { lan },
			} = store.getState();
			store.dispatch(getHomeNewsList(lanMapRoute(lan), {}));
			store.dispatch(getEachHotelAttractions(lanMapRoute(lan)));
		},
	},
	childRoutes: [
		{
			path: ':lang',
			onEnter: ({ params: { lang } }, replace) => {
				const {
					global: { lan, lanList, lanData },
				} = store.getState();

				if (!lanList.map(l => lanData[l].value).includes(lang)) {
					replace('/');
					return;
				}

				if (lanMapRoute(lan) !== lang) {
					changeLng(lang);
				}
			},
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('../Home').default;
							cb(null, component);
						},
						'Main',
					),
				onEnter: ({ params: { lang } }) => {
					store.dispatch(getHomeNewsList(lang, {}));
					store.dispatch(getEachHotelAttractions(lang));
					store.dispatch(getMainPageMeta(lang));
					store.dispatch(getPopupIndex(lang));
				},
			},
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Main/index.js